import * as React from "react";
const SvgFastForward = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "m4 18 8.5-6L4 6v12zm9-12v12l8.5-6L13 6z",
  fill: "currentColor"
}));
export default SvgFastForward;